<div class="height-full" [ngSwitch]="selectedButtonId">

	<div *ngSwitchCase="WebcastViewSidebarButton.ATTENDEES" class="height-full padding-16">
		<webcast-attendees-list [accountId]="accountId" [context]="webcastViewContext" [webcast]="webcast" [isPollingActive]="isAttendeesPollingActive" [themed]="true">
		</webcast-attendees-list>
	</div>

	<div *ngSwitchCase="WebcastViewSidebarButton.INFO">
		<edit-webcast class="box-block padding-16" *ngIf="inlineEdit; else info;" [webcastId]="webcast.id" [isSidebar]="true" [mediaFeatures]="mediaFeatures" (onSaved)="inlineEditCompleted.emit($event)" (onCancelled)="inlineEditCompleted.emit()" (sourceRestartInitiated)="sourceRestartInitiated.emit($event)" (switchStreamInitiated)="switchStreamInitiated.emit()">
		</edit-webcast>
		<ng-template #info>
			<vb-webcast-info-sidebar [webcastViewContext]="webcastViewContext" [webcast]="(webcast.webcast$ | async)">
			</vb-webcast-info-sidebar>
		</ng-template>
	</div>

	<vb-webcast-chat-sidebar *ngSwitchCase="WebcastViewSidebarButton.CHAT" class="padding-bottom-5" [webcast]="(webcast.webcast$ | async)">
	</vb-webcast-chat-sidebar>

	<vb-webcast-questions-sidebar *ngSwitchCase="WebcastViewSidebarButton.QA" [webcast]="(webcast.webcast$ | async)" [sidebarNotifications]="sidebarNotifications" [context]="webcastViewContext">
	</vb-webcast-questions-sidebar>

	<vb-webcast-polls-view *ngSwitchCase="WebcastViewSidebarButton.POLLS" [context]="webcastViewContext" [polls]="(webcast.webcast$ | async).polls" [$polls]="(webcast.webcast$ | async).polls.$polls" [brandingSettings]="ThemeService.brandingSettings$ | async">
	</vb-webcast-polls-view>

	<producer-sidebar *ngSwitchCase="WebcastViewSidebarButton.PRODUCER" [webcast]="webcast">
	</producer-sidebar>

	<producer-controls-sidebar *ngSwitchCase="WebcastViewSidebarButton.PRODUCER_CONTROLS">
	</producer-controls-sidebar>

	<vb-webcast-banner-sidebar *ngSwitchCase="WebcastViewSidebarButton.BANNERS" [webcastId]="webcast.id" [bannerDetails]="(webcast.webcast$ | async).bannerDetails">
	</vb-webcast-banner-sidebar>

	<vb-webcast-embedded-content-sidebar *ngSwitchCase="WebcastViewSidebarButton.EMBEDDED_CONTENT" [webcastId]="webcast.id" [embeddedContent]="(webcast.webcast$ | async).embeddedContent">
	</vb-webcast-embedded-content-sidebar>

	<vb-webcast-dtmf-sidebar *ngSwitchCase="WebcastViewSidebarButton.DTMF" [webcastId]="webcast.id" [codesToReject]="dtmfCodesToReject">
	</vb-webcast-dtmf-sidebar>

	<ng-container *ngFor="let link of webcast.embeddedContent?.contentLinks" class="width-full height-full">
		<vb-webcast-embedded-content *ngSwitchCase="link.id" [contentLink]="link">
		</vb-webcast-embedded-content>
	</ng-container>

</div>
